<script lang="ts">
	export let white = false;
	export let departments: string[] = [];
	let typing = false;
	let backspace = false;
	let text = '';

	function typewriter(node: HTMLParagraphElement, d: string[]) {
		let _departments = d;
		let timeout: ReturnType<typeof setTimeout>;

		typing = true;
		backspace = false;
		text = _departments[0] || '';

		function startTyping() {
			timeout = setTimeout(function () {
				typing = true;
				backspace = false;
				let index = _departments.indexOf(text);
				if (index === _departments.length) index = -1;

				text = _departments[index + 1];

				node.removeEventListener('animationend', startTyping);

				node.addEventListener('animationend', startBackspace);
			}, 1000);
		}

		function startBackspace() {
			timeout = setTimeout(function () {
				typing = false;
				backspace = true;

				node.removeEventListener('animationend', startBackspace);

				node.addEventListener('animationend', startTyping);
			}, 1000);
		}

		node.addEventListener('animationend', startBackspace);

		return {
			update(d: string[]) {
				_departments = d;
			},
			destroy() {
				clearTimeout(timeout);
			}
		};
	}
</script>

<div class="typewritter_text_container" class:is-white={white}>
	<p
		class="typwritter_carousel"
		use:typewriter={departments}
		class:animation_typing={typing}
		class:animation_backspace={backspace}
	>
		{text || ''}
	</p>
</div>

<style lang="postcss">
	.animation_typing {
		animation:
			typing 1.5s steps(28, end),
			blink-caret 0.5s step-end infinite;
	}

	.animation_backspace {
		animation:
			backspace 1.5s steps(30, end),
			blink-caret 0.5s step-end infinite;
		width: 0;
	}

	.is-white .animation_typing {
		animation:
			typing 1.5s steps(28, end),
			blink-caret-white 0.5s step-end infinite;
	}

	.is-white .animation_backspace {
		animation:
			backspace 1.5s steps(30, end),
			blink-caret-white 0.5s step-end infinite;
		width: 0;
	}

	@keyframes typing {
		from {
			width: 0;
		}
		to {
			width: 100%;
		}
	}

	@keyframes backspace {
		from {
			width: 100%;
		}
		to {
			width: 0;
		}
	}

	@keyframes blink-caret {
		from,
		to {
			border-color: transparent;
		}
		50% {
			border-color: theme('colors.orange.400');
		}
	}

	@keyframes blink-caret-white {
		from,
		to {
			border-color: transparent;
		}
		50% {
			border-color: #ffffff;
		}
	}

	@-moz-keyframes spin {
		100% {
			-moz-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}

	@-webkit-keyframes spin {
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}

	@keyframes spin {
		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes sway {
		0%,
		100% {
			transform: rotate(-10deg);
		}
		50% {
			transform: rotate(10deg);
		}
	}

	.typewritter_text_container p.typwritter_carousel {
		@apply text-orange-400 my-auto mx-0 whitespace-nowrap overflow-hidden border-r-2 border-orange-400 tracking-wider;
	}

	.typewritter_text_container {
		display: flex;
		flex-direction: row;
		width: min-content;
	}
</style>
